import { LargeCategoryItem, RadioGroup, CheckboxGroup, TagGroup } from './types';

// Visual Filter Data
export const dummyLargeCategoryData: LargeCategoryItem[] = [
  {
    id: '1',
    name: 'Kurta Suit Sets',
    imageUrl:
      'https://images.unsplash.com/photo-1594633312681-425c7b97ccd1?w=120&h=120&fit=crop&crop=center',
    type: 'single',
    options: []
  },
  {
    id: '2',
    name: 'Sarees',
    imageUrl:
      'https://images.unsplash.com/photo-1523050854058-8df90110c9f1?w=120&h=120&fit=crop&crop=center',
    type: 'single',
    options: []
  },
  {
    id: '3',
    name: 'Tshirts',
    type: 'multiple',
    options: [
      {
        id: '1',
        label: 'Men',
        imageUrl:
          'https://images.unsplash.com/photo-1594633312681-425c7b97ccd1?w=120&h=120&fit=crop&crop=center'
      },
      {
        id: '2',
        label: 'Woman',
        imageUrl:
          'https://images.unsplash.com/photo-1594633312681-425c7b97ccd1?w=120&h=120&fit=crop&crop=center'
      },
      {
        id: '3',
        label: 'Unisex',
        imageUrl:
          'https://images.unsplash.com/photo-1594633312681-425c7b97ccd1?w=120&h=120&fit=crop&crop=center'
      }
    ]
  },
  {
    id: '4',
    name: 'Shirts, Tops & Tunics',
    imageUrl:
      'https://images.unsplash.com/photo-1551698618-1dfe5d97d256?w=120&h=120&fit=crop&crop=center',
    type: 'single',
    options: []
  },
  {
    id: '5',
    name: 'Kurtas & Kurtis',
    imageUrl:
      'https://images.unsplash.com/photo-1594736797933-d0401ba2fe65?w=120&h=120&fit=crop&crop=center',
    type: 'single',
    options: []
  },
  {
    id: '6',
    name: 'Dresses',
    imageUrl:
      'https://images.unsplash.com/photo-1572804013309-59a88b7e92f1?w=120&h=120&fit=crop&crop=center',
    type: 'single',
    options: []
  },
  {
    id: '10',
    name: 'Sneakers & Sports Shoes',
    imageUrl:
      'https://images.unsplash.com/photo-1549298916-b41d501d3772?w=120&h=120&fit=crop&crop=center',
    type: 'single',
    options: []
  }
];

export const dummyQuickFilters = [
  {
    code: 'allfilters',
    name: 'Filter',
    tabPosition: 0
  },
  {
    code: 'sla',
    name: 'SLA',
    tabPosition: 1
  },
  {
    code: 'l1l3nestedcategory',
    name: 'Category',
    tabPosition: 2
  },
  {
    code: 'genderfilter',
    name: 'Gender',
    tabPosition: 3
  },
  {
    code: 'pricerange',
    name: 'Price',
    tabPosition: 4
  },
  {
    code: 'brand',
    name: 'Brands',
    tabPosition: 5
  },
  {
    code: 'occasion',
    name: 'Occasion',
    tabPosition: 6
  },
  {
    code: 'verticalcolorfamily',
    name: 'Colors',
    tabPosition: 7
  },
  {
    code: 'tags',
    name: 'Tags',
    tabPosition: 8
  }
];

export const dummyTopFilterData = [
  {
    filterId: 'visualfilter1',
    defaultDisplayName: 'Diwali Dress',
    imageUrl:
      'https://images.unsplash.com/photo-1594633312681-425c7b97ccd1?w=120&h=120&fit=crop&crop=center',
    isSelected: true
  },
  {
    filterId: 'visualfilter2',
    defaultDisplayName: 'Shirts, Tops & Tunics',
    imageUrl:
      'https://images.unsplash.com/photo-1594633312681-425c7b97ccd1?w=120&h=120&fit=crop&crop=center'
  },
  {
    filterId: 'visualfilter3',
    defaultDisplayName: 'Shirts, Tops & Tunics',
    imageUrl:
      'https://images.unsplash.com/photo-1594633312681-425c7b97ccd1?w=120&h=120&fit=crop&crop=center'
  },
  {
    filterId: 'visualfilter4',
    defaultDisplayName: 'Shirts, Tops & Tunics',
    imageUrl:
      'https://images.unsplash.com/photo-1594633312681-425c7b97ccd1?w=120&h=120&fit=crop&crop=center'
  },
  {
    filterId: 'visualfilter5',
    defaultDisplayName: 'Shirts, Tops & Tunics',
    imageUrl:
      'https://images.unsplash.com/photo-1594633312681-425c7b97ccd1?w=120&h=120&fit=crop&crop=center'
  },
  {
    filterId: 'visualfilter6',
    defaultDisplayName: 'Shirts, Tops & Tunics',
    imageUrl:
      'https://images.unsplash.com/photo-1594633312681-425c7b97ccd1?w=120&h=120&fit=crop&crop=center'
  },
  {
    filterId: 'visualfilter7',
    defaultDisplayName: 'Shirts, Tops & Tunics',
    imageUrl:
      'https://images.unsplash.com/photo-1594633312681-425c7b97ccd1?w=120&h=120&fit=crop&crop=center'
  }
];

// Filter Chips Data
export const dummyRadioFilterData: RadioGroup[] = [
  {
    id: 'sort-by',
    label: 'Sort By',
    options: [
      { id: 'price-high', label: 'Price (highest first)' },
      { id: 'price-low', label: 'Price (lowest first)' },
      { id: 'newest', label: 'Newest First' },
      { id: 'popular', label: 'Most Popular' }
    ]
  }
];

export const dummyCheckboxFilterData: CheckboxGroup[] = [
  {
    id: 'material',
    label: 'Material',
    options: [
      { id: 'cotton', label: 'Cotton' },
      { id: 'polyester', label: 'Polyester' },
      { id: 'silk', label: 'Silk' },
      { id: 'wool', label: 'Wool' },
      { id: 'linen', label: 'Linen' },
      { id: 'rayon', label: 'Rayon' }
    ]
  },
  {
    id: 'size',
    label: 'Size',
    options: [
      { id: 'xs', label: 'XS' },
      { id: 's', label: 'S' },
      { id: 'm', label: 'M' },
      { id: 'l', label: 'L' },
      { id: 'xl', label: 'XL' },
      { id: 'xxl', label: 'XXL' }
    ]
  }
];

export const dummyTagFilterData: TagGroup[] = [
  { id: '1', label: '2 hours' },
  { id: '2', label: 'Same day' },
  { id: '3', label: 'Express' },
  { id: '4', label: 'Free Shipping' }
];
